import React from "react";

export const Cep = (inputElement: React.FormEvent<HTMLInputElement>) => {
    inputElement.currentTarget.maxLength = 9;
    let value = inputElement.currentTarget.value;
    value = value.replace(/\D/g, "");
    value = value.replace(/^(\d{5})(\d)/, "$1-$2");
    inputElement.currentTarget.value = value;
    return inputElement;
}

export const Currency = (inputElement: React.FormEvent<HTMLInputElement>) => {
    let value = inputElement.currentTarget.value;
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d)(\d{2})$/, "$1,$2");
    value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");

    inputElement.currentTarget.value = value;
    return inputElement;
}

export const Cpf = (inputElement: React.FormEvent<HTMLInputElement>) => {
    inputElement.currentTarget.maxLength = 14;
    let value = inputElement.currentTarget.value;
    if (!value.match(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})$/)) {
        value = value.replace(/\D/g, "");
        value = value.replace(/(\d{3})(\d)/, "$1.$2");
        value = value.replace(/(\d{3})(\d)/, "$1.$2");
        value = value.replace(/(\d{3})(\d{2})$/, "$1-$2");
        inputElement.currentTarget.value = value;
    }
    return inputElement;
}

export const Data = (inputElement: React.FormEvent<HTMLInputElement>) => {
    inputElement.currentTarget.maxLength = 10;
    let value = inputElement.currentTarget.value;
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");
    inputElement.currentTarget.value = value;
    return inputElement;
}

export const Hora = (inputElement: React.FormEvent<HTMLInputElement>) => {
    inputElement.currentTarget.maxLength = 5;
    let value = inputElement.currentTarget.value;
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1:$2");
    inputElement.currentTarget.value = value;
    return inputElement;
}
export const Celular = (inputElement: React.FormEvent<HTMLInputElement>) => {
    inputElement.currentTarget.maxLength = 14;
    let value = inputElement.currentTarget.value;
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{0})(\d)/, "$1($2");
    value = value.replace(/(\d{2})(\d)/, "$1)$2");
    value = value.replace(/(\d{5})(\d)/, "$1-$2");
    inputElement.currentTarget.value = value;
    return inputElement;
}